export const carouselImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/pRhpHcn1unvfnaDHHRGvrQ/Captura_de_pantalla_2026-10-12_221803.png',
    alt: 'From Groove to Phrase — The Build Process: 4-step choreography assembly page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gBvF9pb837FewbuKTgfraQ/Captura_de_pantalla_2026-10-12_221714.png',
    alt: 'Build a Combo in 4 Layers: combination building system page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wCho9AJHbrEwoknZqpf4im/Captura_de_pantalla_2026-10-12_221654.png',
    alt: 'Arms Should Support the Groove: arm integration principles page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kqDsJnYvk1kzxNDscCNt1i/Captura_de_pantalla_2026-10-12_221632.png',
    alt: 'Same Move. Different Feel: four movement textures page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/w64kL2JzYwynhQotFwQY5L/Captura_de_pantalla_2026-10-12_221609.png',
    alt: 'One Step. Eight Directions: direction map instructor drill page',
  },
]
